import { render, staticRenderFns } from "./AporteParceiroForm.vue?vue&type=template&id=054519a4"
import script from "./AporteParceiroForm.vue?vue&type=script&lang=js"
export * from "./AporteParceiroForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports